import { render, staticRenderFns } from "./brand_list.vue?vue&type=template&id=28f59b3a&"
import script from "./brand_list.vue?vue&type=script&lang=js&"
export * from "./brand_list.vue?vue&type=script&lang=js&"
import style0 from "./brand_list.vue?vue&type=style&index=0&id=28f59b3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports